export const compareStrings = (
  first?: string | null,
  second?: string | null,
): number => {
  const f = first ?? "";
  const s = second ?? "";

  return f.localeCompare(s);
};

export const compareStringsDesc = (
  first?: string | null,
  second?: string | null,
): number => {
  const f = first ?? "";
  const s = second ?? "";

  return s.localeCompare(f);
};
